// src/config.js
export const SITE_CONFIG = {
  ASSISTANT: { ENABLED: true },
  SITE_ID: 'a.osburn.tulsa',
  LISTING_PREVIEWS_ENABLED: true,
  BASE_URL: 'trescollc.com',
  // Amplify build webhook — fired by BlogManager on publish/edit/delete so new
  // posts get regenerated as crawlable static HTML (see triggerRebuild).
  AMPLIFY_WEBHOOK: 'https://webhooks.amplify.us-east-1.amazonaws.com/prod/webhooks?id=efa2c646-b3cf-48a0-9b1a-033e985553bd&token=Oj3G6NpGgIQbN2579U2bJ3eixg9e0sWf67YaiBE',
  SENDER_EMAIL_ENCRYPTION_KEY: 'ddc32d25f6877ce7692b7361fe9c3cfa75c8fedc8ddbfb6529a636b950fd11bf',
  STATE: 'OK',
  AGENT: {
    MLS_ID: '110594',
    OFFICE_CITY: 'Tulsa',
    NAME: 'Andy Osburn',
    EMAIL: 'osburnandy@gmail.com',
    PHONE: '(918) 398-3660',
    ZILLOW_REVIEW: 'https://www.zillow.com/reviews/write/?s=X1-ZUzkct8hvf3qq1_1brbr',
    GOOGLE_REVIEW: '',
    BROKERAGE_LICENSE: '',
    LICENSE: ''
  },
  MLS: {
    NAME: 'MLS Technology',
    SHORT_NAME: 'MLS Technology',
    LOGO_URL: 'https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/mlstechlogo.png',
    DISCLAIMER: 'Based on information from MLS Technology. All data has not been verified and should be independently reviewed.'
  }
};
